import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/shared/components/ui/card";
import { Terminal, Wrench } from "lucide-react";
import { ServiceLogTerminal } from "./ServiceLogTerminal";
import { GatewayToolsFeed } from "./GatewayToolsFeed";
import { gatewayLogsClient } from "../services/serviceLogsService";

// Gateway tab (PBI 81485): operational Serilog terminal by default, with a "Tools"
// toggle that switches to the anonymized MCP tool-invocation feed.

type ViewMode = "logs" | "tools";

export const GatewayLogsTab = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<ViewMode>("logs");

  const modeButton = (value: ViewMode, label: string, Icon: typeof Terminal) => (
    <button
      type="button"
      aria-pressed={mode === value}
      onClick={() => setMode(value)}
      className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
        mode === value
          ? "bg-background shadow-sm font-medium"
          : "text-muted-foreground hover:text-foreground"
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );

  return (
    <Card className="w-full">
      <CardContent className="pt-6 space-y-4">
        <div className="inline-flex items-center gap-1 rounded-lg bg-muted p-1">
          {modeButton("logs", t("logs.modes.logs", "Logs"), Terminal)}
          {modeButton("tools", t("logs.modes.tools", "Tools"), Wrench)}
        </div>

        {mode === "logs" ? (
          <ServiceLogTerminal
            client={gatewayLogsClient}
            terminalTitle={t("logs.gatewayTerminalTitle", "Terminal de Logs do Gateway")}
          />
        ) : (
          <GatewayToolsFeed />
        )}
      </CardContent>
    </Card>
  );
};
